import { createAsyncThunk } from '@reduxjs/toolkit';
const BASE_URL = process.env.REACT_APP_API_URL + '/users';

async function request(path, options, { signal, rejectWithValue }) {
  try {
    const response = await fetch(BASE_URL + path, {
      ...options, signal,
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token') },
    });
    const data = await response.json();
    if (!response.ok) return rejectWithValue(data.error || data.message || 'Unable to complete the user request.');
    return data;
  } catch (error) { return rejectWithValue(error.message || 'Unable to connect to the server.'); }
}
export const createUserAsync = createAsyncThunk('users/createUserAsync', (data, api) =>
  request('', { method: 'POST', body: JSON.stringify(data) }, api));
export const getUsersAsync = createAsyncThunk('users/getUsersAsync', (role, api) =>
  request(role ? '?role=' + encodeURIComponent(role) : '', { method: 'GET' }, api));
export const getUserByIdAsync = createAsyncThunk('users/getUserByIdAsync', (id, api) =>
  request('/' + encodeURIComponent(id), { method: 'GET' }, api));
export const updateUserAsync = createAsyncThunk('users/updateUserAsync', ({ id, data }, api) =>
  request('/' + encodeURIComponent(id), { method: 'PUT', body: JSON.stringify(data) }, api));
export const getUserRolesAsync = createAsyncThunk('users/getUserRolesAsync', (_, api) =>
  request('/roles', { method: 'GET' }, api));
